import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Button from '../buttons/Button';
import Error from '../error/Error';
var clearBtnSizeMap = {
  md: 'sm',
  lg: 'md',
  xl: 'lg',
  xxl: 'xl'
};

function Input(_ref) {
  var inverse = _ref.inverse,
      error = _ref.error,
      errorState = _ref.errorState,
      borderBottom = _ref.borderBottom,
      classNames = _ref.classNames,
      id = _ref.id,
      type = _ref.type,
      disabled = _ref.disabled,
      icon = _ref.icon,
      iconRight = _ref.iconRight,
      clearable = _ref.clearable,
      forceClearable = _ref.forceClearable,
      onCleared = _ref.onCleared,
      size = _ref.size,
      inputRef = _ref.inputRef,
      keepFocusOnError = _ref.keepFocusOnError,
      otherProps = _objectWithoutProperties(_ref, ["inverse", "error", "errorState", "borderBottom", "classNames", "id", "type", "disabled", "icon", "iconRight", "clearable", "forceClearable", "onCleared", "size", "inputRef", "keepFocusOnError"]);

  var cssClass = classnames('tds-control', {
    'tds-control--inverse': inverse,
    'tds-control--has-error': error || errorState,
    'tds-control--border-bottom': borderBottom,
    'tds-control--is-disabled': disabled,
    'tds-control--sm': size === 'sm',
    'tds-control--lg': size === 'lg',
    'tds-control--xl': size === 'xl'
  }, classNames);
  var input = /*#__PURE__*/React.createElement("input", _extends({
    id: id,
    type: type || 'text',
    className: cssClass,
    disabled: disabled
  }, otherProps, {
    ref: inputRef
  }));
  var clearableWrapper = clearable && typeof otherProps.value === 'string' ? /*#__PURE__*/React.createElement("div", {
    className: classnames('tds-control-input--clearable', {
      'tds-control-input--clearable-sm': size === 'sm',
      'tds-control-input--clearable-lg': size === 'lg',
      'tds-control-input--clearable-xl': size === 'xl',
      'tds-control-input--clearable-is--cleared': otherProps.value === ''
    })
  }, input, otherProps.value !== '' && size !== 'sm' && /*#__PURE__*/React.createElement(Button, {
    disabled: disabled && !forceClearable,
    theme: "tertiary",
    icon: "clear",
    onClick: function onClick(evt) {
      return onCleared && onCleared(evt);
    },
    size: clearBtnSizeMap[size],
    type: "button"
  })) : input;
  var wrapped = icon ? /*#__PURE__*/React.createElement("div", {
    className: classnames('tds-control-icon-wrapper', {
      'tds-control-icon-wrapper--is-left': !iconRight,
      'tds-control-icon-wrapper--is-right': iconRight,
      'tds-control-icon-wrapper--sm': size === 'sm',
      'tds-control-icon-wrapper--lg': size === 'lg',
      'tds-control-icon-wrapper--xl': size === 'xl'
    })
  }, !iconRight && icon, !iconRight ? clearableWrapper : input, iconRight && icon) : clearableWrapper;
  return error || keepFocusOnError ? /*#__PURE__*/React.createElement("div", {
    className: error ? 'tds-control-error-wrapper' : ''
  }, wrapped, error && /*#__PURE__*/React.createElement(Error, {
    error: error
  })) : wrapped;
} // Props used also in DatalistGroup and InputGroup


Input.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'lg', 'md', 'xl']),
  list: PropTypes.string,
  classNames: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  inverse: PropTypes.bool,
  error: PropTypes.node,
  borderBottom: PropTypes.bool,
  disabled: PropTypes.bool,
  icon: PropTypes.node,
  onCleared: PropTypes.func,
  iconRight: PropTypes.bool,
  errorState: PropTypes.bool,
  clearable: PropTypes.bool,

  /**
   * If you want dynamic errors to appear while you
   * type you set this prop to true
   */
  keepFocusOnError: PropTypes.bool,

  /**
   * If we want the clearable button to be always clickable, even if
   * input is disabled
   */
  forceClearable: PropTypes.bool,
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })])
};
Input.defaultProps = {
  size: 'md',
  inputRef: function inputRef() {},
  type: '',
  list: '',
  classNames: '',
  inverse: false,
  error: null,
  borderBottom: false,
  disabled: false,
  icon: null,
  onCleared: function onCleared() {},
  iconRight: false,
  errorState: false,
  clearable: false,
  forceClearable: false,
  keepFocusOnError: false
};
export default Input;